<template>
  <section>
    <v-dialog v-model="trackDialog">
      <div class="dialog-container">
        <h3>Enter Tracking Number</h3>
        <el-form
          ref="form"
          :model="formData"
          :rules="rules">
          <el-form-item
            prop="number"
            class="form-item">
            <span>Tracking Number</span>
            <v-input v-model="formData.number" />
          </el-form-item>
        </el-form>
        <div class="flex-sb">
          <div>
            <v-button @click="handlerCancel">Cancel</v-button>
          </div>
          <div>
            <v-button
              type="success"
              @click="handlerSave">Save</v-button>
          </div>
        </div>

      </div>
    </v-dialog>

    <send-email-sms
      ref="send-email-sms"
      :form="customer"
      :initContent="sms"
      @cancel="handleCancel"
      @skip="handleSkip"
      @send="handlerSend" />
  </section>
</template>

<script>
import SendEmailSms from './send-email-sms'
export default {
  name: 'Tracking',
  components:{
    SendEmailSms
  },
  props:{
    num:{
      type: String,
      default: ''
    },
    sms:{
      type: String,
      default: ''
    },
    customer:{
      type: Object,
      default: () => {}
    },
  },
  data () {
    return {
      trackDialog: false,
      formData:{
        number: ''
      },
      rules:{
        number: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] },
        ],
      },
    }
  },
  watch:{
    num:{
      immediate: true,
      handler(val){
        this.formData.number = val
      }
    }
  },
  methods: {
    changeDialog(){
      this.trackDialog = !this.trackDialog
    },

    resetForm(){
      this.$refs.form.resetFields()
    },

    handlerCancel(){
      this.trackDialog = false
      this.$refs.form.resetFields()
    },

    handlerSave(){
      this.$refs.form.validate(val => {
        if(val){
          this.trackDialog = false
          this.$refs['send-email-sms'].changeDialog()
        }
      })
    },
    handleSkip(){
      let params = {
        track_number: this.formData.number,
        is_send: 0,
      }
      this.$emit('saveTracking', params)
    },
    handlerSend(val){
      let params = {
        track_number: this.formData.number,
        is_send: 1,
        content: val.content
      }
      this.$emit('saveTracking', params)
    },
    handleCancel(){
      this.$refs['send-email-sms'].changeDialog()
    }
  },
}
</script>
<style lang='scss' scoped>
.dialog-container{
  padding: 15px;
  .form-item{
    span{
      display: block;
      padding-bottom: 5px;
      font-size: 14px;
      color: #24292e;
      font-family: Inter;
      font-weight: 600;
      letter-spacing: 0;
      line-height: 17px;
    }
  }
}
</style>
